import { useState, useEffect } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@heroui/react";
import { Checkmark, Close } from "assets/icons";
import { API_URL } from "constants/index";
import ButtonNew from "components/buttonNew/buttonNew";
import { useResources } from "shared/contexts/resources.context";
import { ResourceType } from "shared/types/resource";
import {
  Buildings,
  ChatCircle,
  FileText,
  Lifebuoy,
  WhatsappLogo,
} from "@phosphor-icons/react";
import SearchComponent, {
  SearchMode,
} from "shared/components/searchBar/components/searchComponent";
import { RentalContract } from "shared/types/rental-contracts";

const StartCommunicationModal = ({ isOpen, onOpenChange, onClose }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [buildingId, setBuildingId] = useState<string | null>(null);
  const [rentalContract, setRentalContract] = useState<RentalContract | null>(
    null,
  );
  // const [selectedCommunicationChannel, setSelectedCommunicationChannel] =
  //   useState<string>("tenant");

  const [unitId, setUnitId] = useState<string | null>(null);
  const { resources } = useResources();

  useEffect(() => {
    console.log(isLoading);
    setIsLoading(false);
  }, []);

  // Regex to extract building ID from unit ID
  const buildingIdRegex = /^(\d+-[A-Z]+-\d+)/;

  // Filter buildings based on your regex
  const filteredBuildings = resources.filter(
    (resource) =>
      resource.type === ResourceType.BUILDING &&
      buildingIdRegex.test(resource.resourceId),
  );

  // const handleUnitSelect = (resource: any) => {
  //   const match = resource.resourceId.match(buildingIdRegex);
  //   if (match) {
  //     const extractedBuildingId = match[1];
  //     setBuildingId(extractedBuildingId);
  //   }
  //   setUnitId(resource.resourceId);
  // };

  const handleBuildingSelect = (resource: any) => {
    setBuildingId(resource.resourceId);
    // Automatically set units to those under the selected building
  };

  const handleContractSelect = (rentalContract: RentalContract) => {
    setRentalContract(rentalContract);
  };

  // const handleSelectedCommunicationChannel = (value: string) => {
  //   setSelectedCommunicationChannel(value);
  // };
  const handleClose = () => {
    setBuildingId(null);
    setUnitId(null);
    setRentalContract(null);
    onClose();
  };

  const filteredUnits = buildingId
    ? resources.filter(
        (resource) =>
          resource.type === ResourceType.UNIT &&
          resource.resourceId.startsWith(buildingId),
      )
    : [];

  return (
    <>
      <Modal
        scrollBehavior="inside"
        hideCloseButton
        size="5xl"
        className="h-screen"
        isOpen={!isLoading && isOpen}
        onClose={handleClose}
        onOpenChange={onOpenChange}
      >
        <ModalContent>
          <ModalHeader className="flex items-center justify-between font-normal">
            <div className="flex items-center gap-2">
              <WhatsappLogo weight="duotone" size={22} />
              <p>
                Start nieuwe communicatie in gebouw of met specifieke huurder
              </p>
            </div>
            <div className="flex items-center gap-2">
              {!isLoading && (
                <ButtonNew
                  variant="primaryMoss"
                  icon={<Checkmark />}
                  label="Bewaren"
                  isDisabled={isLoading}
                />
              )}

              {isLoading && (
                <ButtonNew
                  variant="primaryMoss"
                  icon={<Spinner />}
                  label="Aan het bewaren..."
                />
              )}
              <Button
                onClick={() => onOpenChange(false)}
                isIconOnly
                variant="light"
                className="text-neutral-secondary-mid"
              >
                <Close />
              </Button>
            </div>
          </ModalHeader>
          <ModalBody>
            <section className="flex flex-col gap-6">
              <div className="flex gap-3 *:flex *:w-full *:flex-col *:gap-2 *:rounded-md *:border *:border-neutral-primary/20 *:p-3">
                <div>
                  <header className="flex items-center gap-1 text-sm font-medium">
                    <Buildings weight="duotone" size={18} />
                    <p>Gebouw</p>
                  </header>
                  <SearchComponent
                    editMode={true}
                    label="Selecteer gebouw"
                    onSelect={handleBuildingSelect}
                    resourceFilter={[ResourceType.BUILDING]}
                    initialValue={buildingId || ""}
                    mode={SearchMode.SEARCH_AND_PRESENT}
                    customData={filteredBuildings}
                  />
                </div>
              </div>
            </section>
            <section>
              {/* Show table of units if a building is selected */}
              {buildingId && (
                <div className="mt-4">
                  <Table aria-label="List of Units">
                    <TableHeader>
                      <TableColumn>Unit</TableColumn>
                      <TableColumn>Huurder</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {filteredUnits.map((unit) => (
                        <TableRow key={unit.resourceId}>
                          <TableCell>{unit.name}</TableCell>
                          <TableCell>{unit.name}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </section>
            {buildingId && unitId && (
              <div className="mt-4 flex flex-col gap-2">
                <header className="flex items-center gap-1 text-sm font-medium">
                  <FileText weight="duotone" size={18} />
                  <p>Huurcontract</p>
                </header>
                <SearchComponent
                  editMode={true}
                  label="Selecteer contract"
                  onSelect={handleContractSelect}
                  initialValue={rentalContract ? rentalContract.id : ""}
                  mode={SearchMode.SEARCH_AND_PRESENT}
                  api={`${API_URL}/search/rental/unit/${unitId}/contracts`}
                />
              </div>
            )}

            <div className="mt-4 flex flex-col gap-2">
              <div className="flex items-center gap-1 text-sm">
                <Lifebuoy weight="duotone" size={18} />
                <p>Link met helpdeskticket?</p>
              </div>
              Searchcomponent met api filter here
            </div>

            <div className="mt-4 flex flex-col gap-2">
              <div className="flex items-center gap-1 text-sm">
                <ChatCircle weight="duotone" size={18} />
                <p>Link met conversaties?</p>
              </div>
              Searchcomponent met api filter here
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default StartCommunicationModal;
